import { render, staticRenderFns } from "./CertificateAlertDialog.vue?vue&type=template&id=f12322e2"
import script from "./CertificateAlertDialog.vue?vue&type=script&lang=js"
export * from "./CertificateAlertDialog.vue?vue&type=script&lang=js"
import style0 from "./CertificateAlertDialog.vue?vue&type=style&index=0&id=f12322e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports